import api from "./api";

// CRUD aninhado em /api/roteiros/{roteiroId}/tarefas
export async function listTarefas(roteiroId) {
  const { data } = await api.get(`/roteiros/${roteiroId}/tarefas`);
  return data;
}

export async function getTarefa(roteiroId, id) {
  const { data } = await api.get(`/roteiros/${roteiroId}/tarefas/${id}`);
  return data;
}

export async function createTarefa(roteiroId, payload) {
  const { data } = await api.post(`/roteiros/${roteiroId}/tarefas`, payload);
  return data;
}

export async function updateTarefa(roteiroId, id, payload) {
  await api.put(`/roteiros/${roteiroId}/tarefas/${id}`, payload);
}

export async function updateTarefaStatus(roteiroId, id, status) {
  await api.patch(`/roteiros/${roteiroId}/tarefas/${id}/status`, { status });
}

export async function deleteTarefa(roteiroId, id, despesaAction) {
  const params = despesaAction ? { despesa: despesaAction } : undefined;
  await api.delete(`/roteiros/${roteiroId}/tarefas/${id}`, { params });
}

// Status: 0 Pendente, 1 Concluida (bate com enum backend)
export const STATUS_TAREFA = {
  Pendente: 0,
  Concluida: 1,
};

export const TIPO_TAREFA_OPTIONS = [
  { value: 0, label: "Transporte", icon: "🚐" },
  { value: 1, label: "Hospedagem", icon: "🏨" },
  { value: 2, label: "Ingressos", icon: "🎟️" },
  { value: 3, label: "Alimentação", icon: "🍽️" },
  { value: 4, label: "Guia local", icon: "🗣️" },
  { value: 5, label: "Outros", icon: "📋" },
];

export function tipoTarefaLabel(tipo) {
  return TIPO_TAREFA_OPTIONS.find((t) => t.value === tipo)?.label ?? "—";
}

export function tipoTarefaIcon(tipo) {
  return TIPO_TAREFA_OPTIONS.find((t) => t.value === tipo)?.icon ?? "📋";
}

// Classifica uma tarefa por proximidade de vencimento (pra cor do badge).
// Retorna: "vencida" | "proxima" | "futura" | "sem_data" | "concluida"
export function vencimentoStatus(tarefa) {
  if (tarefa.status === STATUS_TAREFA.Concluida) return "concluida";
  if (!tarefa.dataVencimento) return "sem_data";
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const venc = new Date(tarefa.dataVencimento);
  const dias = Math.floor((venc - hoje) / (1000 * 60 * 60 * 24));
  if (dias < 0) return "vencida";
  if (dias <= 3) return "proxima";
  return "futura";
}
